"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var core_1 = require("@material-ui/core");

var core_2 = require("@material-ui/core");

var classnames_1 = __importDefault(require("classnames"));

var formik_1 = require("formik");

var react_1 = __importDefault(require("react"));

var check_mark_svg_1 = __importDefault(require("../assets/images/check-mark.svg"));

exports.BB8InnerFormField = function (props) {
  return react_1.default.createElement("div", {
    className: props.classes.root,
    style: {
      flexDirection: "column"
    }
  }, react_1.default.createElement(core_2.FormHelperText, {
    style: {
      marginLeft: 8
    },
    error: !!props.error,
    id: "component-error-text"
  }, props.label), react_1.default.createElement(core_2.TextField, {
    id: props.id,
    name: props.name,
    className: classnames_1.default(props.classes.margin, props.classes.textField),
    variant: "outlined",
    value: props.value,
    onChange: props.onChange,
    onBlur: props.onBlur,
    helperText: props.error,
    error: !!props.error,
    disabled: props.disabled || false,
    placeholder: props.placeholder,
    select: !!props.ranges,
    required: props.required,
    type: props.type,
    InputProps: TextFieldAdornments(props.validAdornment, props.loadingAdornment, props.loading, !props.error),
    inputProps: {
      autoCapitalize: "on",
      maxLength: props.maxLength
    },
    autoFocus: props.autoFocus
  }, props.ranges && props.ranges.map(function (option) {
    return react_1.default.createElement(core_2.MenuItem, {
      key: option.value,
      value: option.value
    }, option.label);
  })));
};

function TextFieldAdornments(validAdornment, loadingAdornment, loading, valid) {
  if (loadingAdornment && loading) {
    return {
      endAdornment: react_1.default.createElement(core_2.InputAdornment, {
        position: "end"
      }, react_1.default.createElement(core_1.CircularProgress, null))
    };
  }

  if (validAdornment && valid) {
    return {
      endAdornment: react_1.default.createElement(core_2.InputAdornment, {
        position: "end"
      }, react_1.default.createElement("img", {
        alt: "checkmark-success",
        src: check_mark_svg_1.default
      }))
    };
  }

  return {};
}
/**
 * This component wraps BB8Form Field with Formik Field component. For more details
 * please check {@link https://jaredpalmer.com/formik/docs/api/field}
 * @param props Form field props
 */


var BB8FormField = function BB8FormField(props) {
  return react_1.default.createElement(formik_1.Field, {
    name: props.name,
    validate: props.validate
  }, function (_a) {
    var field = _a.field,
        form = _a.form;
    return react_1.default.createElement(exports.BB8InnerFormField, __assign({}, props, field, {
      // triggers formik onChange and also the passed in onChange from the caller
      // tslint:disable-next-line:jsx-no-lambda
      onChange: function onChange(e) {
        field.onChange(e);

        if (props.onChange) {
          props.onChange(e.target.value);
        }
      },
      error: props.error || form.touched[field.name] && form.errors[field.name],
      value: props.value || form.values && form.values[field.name]
    }));
  });
};

var styles = core_1.createStyles(function (theme) {
  return {
    margin: {
      margin: theme.spacing.unit
    },
    root: {
      display: "flex",
      flexWrap: "wrap"
    },
    textField: {
      flexBasis: 100
    }
  };
});
exports.default = core_1.withStyles(styles)(BB8FormField);